import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const BRANCH_DELETE_RESOURCE = "branch" as const;
export const BRANCH_DELETE_API_PATH = `/v1/${BRANCH_DELETE_RESOURCE}/{uuid}` as const;

export type BranchDeleteResponse =
  paths[typeof BRANCH_DELETE_API_PATH]["delete"]["responses"][200]["content"]["application/json"];

export const useBranchDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<BranchDeleteResponse, Error, { uuid: string; force?: boolean }>({
    mutationFn: async ({ uuid, force }) => {
      const requestConfig = force === true ? { params: { force: true } } : undefined;
      const response = await alphartisApiAxios.delete<BranchDeleteResponse>(
        `/v1/${BRANCH_DELETE_RESOURCE}/${uuid}`,
        requestConfig,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [BRANCH_DELETE_RESOURCE, "search"],
      });
    },
  });
};
